import { forwardRef, type ForwardRefRenderFunction } from 'react';

import { useModifiers } from '../../../../styles/hooks/useModifiers';

import styles from './drawerDragHandle.module.css';

interface DrawerDragHandleProps {
  className?: string;
}

export const DrawerDragHandleRenderer: ForwardRefRenderFunction<HTMLDivElement, DrawerDragHandleProps> = (
  { className },
  ref
) => {
  const mods = useModifiers(
    styles,
    'drawer__headerHandle__wrapper',
    {},
    { withBaseClass: true, extraClassName: className }
  );

  return (
    <div className={mods} ref={ref}>
      <div data-testid="nav-drawer-handle" className={styles.drawer__headerHandle} />
    </div>
  );
};

export const DrawerDragHandle = forwardRef(DrawerDragHandleRenderer);
